import React, { CSSProperties } from 'react';

interface ChevronRightProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const ChevronRight: React.FC<ChevronRightProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill={fill}>
        <defs />
        <path className="cls-1" d="M405 280l250 250-250 250" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
      </g>
    </svg>
  );
};

export default ChevronRight;
